import { Component, OnInit } from '@angular/core';
import {GeneralService} from '../../../../../service/general-service';
import {NzModalService} from 'ng-zorro-antd/modal';
import {NotificationService} from '../../../../../service/notification.service';
import {TranslateService} from '@ngx-translate/core';
import {AppConfigService} from '../../../../../../app-config.service';
import {FormBuilder} from '@angular/forms';

@Component({
  selector: 'app-search-chemical',
  templateUrl: './search-chemical.component.html',
  styleUrls: ['./search-chemical.component.scss']
})
export class SearchChemicalComponent implements OnInit {
  searchText: any;
  searchData: any;
  constructor(
    private generalService: GeneralService,
    private modalService: NzModalService,
    private notificationService: NotificationService,
    public translate: TranslateService,
    private configService: AppConfigService,
    private fb: FormBuilder
  ) {
    this.searchText = '';
  }

  ngOnInit(): void {
    this.doSearch();
  }
  doSearch(){
    if (this.searchText.length !== 8) {
      return;
    }
    this.generalService.getInventoryHistory(this.searchText).subscribe(res => {
      if (res !== null) {
        console.log(res);
        this.searchData = res;
        this.searchText = '';
      }
    }, error => {

    });
  }
}
